import React, { useEffect, useState } from 'react'

import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Autoplay, EffectFade } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/swiper.scss';
// import "swiper/components/effect-fade/effect-fade.scss"
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/scrollbar/scrollbar.scss';

import CompanyLogo1 from '../../images/companies/byreesedeluca.png'
import CompanyLogo2 from '../../images/companies/english-buzz.png'
import CompanyLogo3 from '../../images/companies/flowcast.png'
import CompanyLogo4 from '../../images/companies/kindness-culture.png'
import CompanyLogo5 from '../../images/companies/kristina-webb.png'
import CompanyLogo6 from '../../images/companies/lead-o-top.png'
import CompanyLogo7 from '../../images/companies/noxlio.jpeg'
import CompanyLogo8 from '../../images/companies/rawmax.png'


SwiperCore.use([ Autoplay, Navigation, Pagination, Scrollbar, A11y ]);

const Companies = () => {

    const Slides = [
        {
            img: CompanyLogo1
        },
        {
            img: CompanyLogo2,
        },
        {
            img: CompanyLogo3
        },
        {
            img: CompanyLogo4
        },
        {
            img: CompanyLogo5
        },
        {
            img: CompanyLogo6
        },
        {
            img: CompanyLogo7
        },
        {
            img: CompanyLogo8
        },
    ]

    const [screenWidth, setScreenWidth] = useState('')
    const [slidesPerview, setSlidesPerview] = useState(0)

    useEffect(()=> {
        if(typeof window !== 'undefined') {
            setScreenWidth(window.innerWidth)
        }
    })

    useEffect(()=> {
        let screen = parseInt(screenWidth)
            if( screen < 360){
                setSlidesPerview(2);
            } else if( screen >= 360 && screen < 640){
                setSlidesPerview(3);
            }else if( screen >= 640 && screen < 1024){
                setSlidesPerview(4);
            }else  if( screen >= 1024){
                setSlidesPerview(5);
            }else {
                setSlidesPerview(5);
            }
    }, [screenWidth])

    return (
        <>
            <section id="companies-integration-page" className="w-full md:w-4/5 px-2 md:px-0 pt-44 xs:pt-36 md:pt-44 lg:pt-16 pb-10 md:pb-14 lg:pb-16 mx-auto text-center">
                <div className="w-full mx-auto space-y-14">
                    <div className="w-full px-2 md:px-3 2xl:w-8/12 mx-auto text-lg xs:text-xl md:text-2xl lg:text-3xl leading-7 xs:leading-8 md:leading-9 lg:leading-50px text-secondary font-medium font-poppins text-center">
                        135,529+ subscribers are using Optinly to turn their traffic into subscribers, leads and sales.
                    </div>

                    {/* Swiper section */}
                    <div className="w-full">
                        <Swiper
                            spaceBetween={5}
                            loop= {true}
                            autoplay={{ delay: 2000 }}
                            slidesPerView={slidesPerview}
                            pagination={false}
                            scrollbar={false}
                            effect="fade"
                            >
                            {
                            Slides.map((slide)=>(
                                <SwiperSlide>
                                    {slide.img &&
                                        <img className="h-7 xs:h-8 md:h-9" src={slide.img} alt="" />
                                    }
                                </SwiperSlide>
                            ))
                            }
                        </Swiper>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Companies
